<template>
  <el-card v-loading="tableLoading">
    <!-- /* ---------------------------------- 表单查询 ---------------------------------- */ -->
    <el-row>
      <el-form :model="form" v-bind="formProps.form" :rules="{}">
        <el-row>
          <el-form-item :label="$t('orders.label.form.submitTime')">
            <range-date-picker ref="datePick" @showDateTime="handleSetDateTime" />
            <!--            <el-date-picker type="datetime" size="small" v-model="form.submitTimeStart" value-format="yyyy-MM-dd HH:mm:ss" />-->
            <!--            <span>~</span>-->
            <!--            <el-date-picker type="datetime" size="small" v-model="form.submitTimeEnd" value-format="yyyy-MM-dd HH:mm:ss" />-->
            <!--            <el-button-->
            <!--              size="mini"-->
            <!--              type="primary"-->
            <!--              v-for="(btn, key) in btnsTime"-->
            <!--              :key="key + Math.random()"-->
            <!--              @click="handleTime(key, 'submit')"-->
            <!--              round>{{ btn }}-->
            <!--            </el-button>-->
          </el-form-item>
          <el-form-item :label="$t('orders.label.table.payoutTime')">
            <range-date-picker
              ref="rangeDatePick"
              :need-init="false"
              @showDateTime="handleShowRangeTime"
            />
            <!--            <el-date-picker type="datetime" size="small" v-model="form.payoutTimeStart" value-format="yyyy-MM-dd HH:mm:ss" />-->
            <!--            <span>~</span>-->
            <!--            <el-date-picker type="datetime" size="small" v-model="form.payoutTimeEnd" value-format="yyyy-MM-dd HH:mm:ss" />-->
            <!--            <el-button-->
            <!--              size="mini"-->
            <!--              type="primary"-->
            <!--              v-for="(btn, key) in btnsTime"-->
            <!--              :key="key + Date.now()"-->
            <!--              @click="handleTime(key)"-->
            <!--              round>{{ btn }}-->
            <!--            </el-button>-->
          </el-form-item>
        </el-row>

        <el-form-item :label="$t('orders.label.form.channelType')">
          <el-select v-model="form.channelType">
            <el-option v-for="item in channelTypeList" :key="item" :value="item"></el-option>
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('orders.label.form.merchatNo')">
          <el-input v-model="form.merchatNo"></el-input>
        </el-form-item>

        <!-- <el-form-item prop="patchStatus" :label="$t('orders.label.form.patchStatus')">
          <el-select v-model="form.patchStatus">
            <template v-for="item in statusData.patchStatus">
              <el-option :key="item.label" :label="item.label" :value="item.val" />
            </template>

            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item :label="$t('orders.label.form.callbackStatus')">
          <el-select v-model="form.callbackStatus">
            <el-option
              v-for="item in statusData.callbackStatus"
              :key="item.label"
              :label="item.label"
              :value="item.val"
            ></el-option>
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('orders.label.form.orderStatus')">
          <el-select v-model="form.orderStatus">
            <el-option
              v-for="item in statusData.orderStatus"
              :key="item.label"
              :label="item.label"
              :value="item.val"
            ></el-option>
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('wallet.label.merchatOrderNo')">
          <el-input v-model="form.merchatOrderNo"></el-input>
        </el-form-item>
        <el-form-item :label="$t('orders.label.form.systemOrderNo')">
          <el-input v-model="form.systemOrderNo"></el-input>
        </el-form-item>

        <el-form-item :label="$t('device.remark')">
          <el-input v-model="form.description"></el-input>
        </el-form-item>
        <el-form-item :inline="true" :label="$t('orders.label.form.amountStart')">
          <div style="display: flex">
            <el-input size="mini" v-model.trim="form.amountStart"></el-input>
            <span>-</span>
            <el-input size="mini" v-model.trim="form.amountEnd"></el-input>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button size="mini" type="primary" @click="handleEmpty()">{{
            $t('btns.empty')
          }}</el-button>
          <el-button size="mini" type="primary" @click="handleSearch()" :loading="searchLoading">{{
            $t('btns.search')
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <!-- /* ---------------------------------- 表格展示 ---------------------------------- */ -->
    <el-row>
      <div class="header-table">
        <ul class="list-table">
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t('orders.label.list.totalNumber') }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.orderNumberTotal | toThousands }}
            </span>
          </li>
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t('orders.label.list.totalSuccessMoney') }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.paymentAmountTotal | toThousands }}
            </span>
          </li>
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t('orders.label.list.totalMoney') }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.actualAmountTotal | toThousands }}
            </span>
          </li>
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t('orders.label.list.totalfee') }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.handlingFeeTatal | toThousands }}
            </span>
          </li>

          <li class="li-table">
            <em class="label">
              <span>
                {{ $t('orders.label.list.makeupAmount') }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.makeupAmount | toThousands }}
            </span>
          </li>
        </ul>

        <div class="btn-table">
          <!-- <el-switch
            v-model="refresh"
            @change="refTableData"
            :active-text="$t('btns.start1')"
            :inactive-text="$t('btns.stop1')"
          >
          </el-switch> -->
          <el-button
            size="mini"
            plain
            icon="el-icon-download"
            v-if="tableList.length && permission.indexOf(`export:orderRecord`) > -1"
            @click="handleExport"
          >
            {{ $t('btns.export') }}
          </el-button>
        </div>
      </div>

      <el-table
        :data="tableList"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }"
        stripe
      >
        <el-table-column prop="systemOrderNo" :label="$t('orders.label.table.systemOrderNo')"  width="150px" >
          <template slot-scope="{ row }">
            <i
              :title="$t('onlinememberdrawal.copy')"
              class="fa fa-clipboard"
              style="color: #777; cursor: pointer"
              @click="copyText(row.systemOrderNo)"
            ></i>
            <router-link v-if="userType === 0" :to="{ name: 'transactionRecord', query: { systemOrderNo: row.systemOrderNo } }">
              {{ row.systemOrderNo }}
            </router-link>
            <span v-else>
              {{ row.systemOrderNo }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="merchatOrderNo" :label="$t('orders.label.table.merchatOrderNo')"  width="150px" >
          <template slot-scope="{ row }">
            <i
              :title="$t('onlinememberdrawal.copy')"
              class="fa fa-clipboard"
              style="color: #777; cursor: pointer"
              @click="copyText(row.merchatOrderNo)"
            ></i>
            <span :style="needChangeColor(row.submitAmount)">{{ row.merchatOrderNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="merchatNo" :label="$t('orders.label.table.merchatNo')">
          <template slot-scope="{ row }">
            <span :style="needChangeColor(row.submitAmount)">{{ row.merchatNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="merchantName" :label="$t('clientmanage.table.merchantName')" />
        <el-table-column prop="channelCode" :label="$t('channel.label.channelCode')">
          <template slot-scope="{ row }">
            <span v-if="row.channelType === 'momo_qr'" :style="needChangeColor(row.submitAmount)">
              {{ row.remark }}
            </span>
            <span v-else :style="needChangeColor(row.submitAmount)">
              {{ row.channelCode }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="submitAmount" :label="$t('orders.label.table.submitAmount')">
          <template slot-scope="{ row }">
            <span :style="needChangeColor(row.submitAmount)">{{
              row.submitAmount | toThousands
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="handlingFee" :label="$t('orders.label.table.handlingFee')">
          <template slot-scope="{ row }">
            <span :style="needChangeColor(row.submitAmount)">
              {{ row.handlingFee | toThousands }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="nowAmount" :label="$t('orders.label.table.nowAmount')">
          <template slot-scope="{ row }">
            <span :style="needChangeColor(row.submitAmount)">
              {{ (row.paymentAmount - row.handlingFee) | toThousands }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="description" :label="$t('device.remark')">
          <template slot-scope="{ row }">
            <span :style="needChangeColor(row.submitAmount)">
              {{ row.description }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="channelType" :label="$t('orders.label.table.channelType')">
          <template slot-scope="{ row }">
            <span :style="needChangeColor(row.submitAmount)">
              {{ row.channelType }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="accountNumber" :label="$t('device.receiverNumber')"  v-if="!info.userType" />
        <el-table-column prop="callbackStatus" :label="$t('orders.label.table.callbackStatus')" width="80px">
          <template slot-scope="{ row }">
            <template v-if="statusData.callbackStatus.length">
              <el-tag
                v-for="item in statusData.callbackStatus"
                :key="item.label"
                :type="item.type"
                v-show="row.callbackStatus == item.val"
              >
                <span>{{ item.label }} </span>
              </el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" :label="$t('orders.label.table.orderStatus')" width="80px">
          <template slot-scope="{ row }">
            <el-tag
              v-for="item in statusData.orderStatus"
              :key="item.label"
              :type="item.type"
              width="70px"
              v-show="row.orderStatus === item.val "
              :class="getOrderClass(row.orderStatus)"
            >
              <span
                >{{ userType !== 0 && row.orderStatus === 2 ? $t('status.success5') : item.label }}
              </span>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="patcher" :label="$t('orders.label.table.patcher')">
          <template slot-scope="{ row }">
            <span :style="needChangeColor(row.submitAmount)">
              {{ row.patcher }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('channel.label.createTime')">
          <template slot-scope="{ row }">
            <span :style="needChangeColor(row.submitAmount)">{{ row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payoutTime" :label="$t('orders.label.table.payoutTime')">
          <template slot-scope="{ row }">
            <span :style="needChangeColor(row.submitAmount)">{{ row.payoutTime | asDayjs }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="channelName"
          :label="$t('channel.label.channelName')"
          v-if="permission.indexOf('manual:transaction') > -1"
        >
          <template slot-scope="{ row }">
            <span :style="needChangeColor(row.submitAmount)">{{ row.channelName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('accountmanager.operation')"
          v-if="
            permission.indexOf('manual:transaction') > -1 ||
            permission.indexOf('orderRecord:updateCardOrder') > -1
          "
        >
          <template slot-scope="scope">
            <el-popconfirm
              :title="$t('orders.tip.danger')"
              :ref="`popover-${scope.row.id}-1`"
              @confirm="getCallback(scope.row)"
              :key="`${scope.row.id}-1`"
            >
              <el-button
                size="mini"
                type="primary"
                slot="reference"
                v-if="
                  (scope.row.orderStatus == 1 || scope.row.orderStatus == 2) &&
                  scope.row.callbackStatus != 1
                "
              >
                {{ $t('btns.callback') }}
              </el-button>
            </el-popconfirm>
            <template v-if="scope.row.orderStatus != 1 && scope.row.orderStatus != 2">
              <el-popconfirm
                :title="`${$t('orders.tip.danger')}`"
                :ref="`popover-${scope.row.id}-2`"
                @confirm="getManual(scope.row)"
                :key="`${scope.row.id}-2`"
              >
                <el-button size="mini" type="danger" slot="reference">
                  {{ $t('btns.manual') }}
                </el-button>
              </el-popconfirm> 
            </template>
          </template>
        </el-table-column>
        <!-- <el-table-column
          :label="$t('accountmanager.operation')"
          v-if="
            permission.indexOf('manual:transaction') > -1 ||
            permission.indexOf('orderRecord:updateCardOrder') > -1
          "
        >
          <template slot-scope="scope">
            <el-popconfirm
              :title="$t('orders.tip.danger')"
              :ref="`popover-${scope.row.id}-1`"
              @confirm="getCallback(scope.row)"
              :key="`${scope.row.id}-1`"
            >
              <el-button
                size="mini"
                type="primary"
                slot="reference"
                v-if="
                  (scope.row.orderStatus == 1 || scope.row.orderStatus == 2) &&
                  scope.row.callbackStatus != 1
                "
              >
                {{ $t('btns.callback') }}
              </el-button>
            </el-popconfirm>
            <template v-if="scope.row.orderStatus != 1 && scope.row.orderStatus != 2">
              <el-popconfirm
                :title="`${$t('orders.tip.danger')}`"
                :ref="`popover-${scope.row.id}-2`"
                @confirm="getManual(scope.row)"
                :key="`${scope.row.id}-2`"
                v-if="scope.row.channelType !== 'card_pc'"
              >
                <el-button size="mini" type="danger" slot="reference">
                  {{ $t('btns.manual') }}
                </el-button>
              </el-popconfirm>
              <cardDialog v-else :row="scope.row" @getTable="getTableData"></cardDialog>
            </template>
          </template>
        </el-table-column> -->
      </el-table>
    </el-row>

    <v-pagination
      v-model="pagination"
      :sizes="[20, 50, 100, 500]"
      :size="pagination.size"
      :total="tableData.rows"
      @update="getTableData"
    />

    <!-- <el-dialog title="" :visible.sync="visibleDialogBool">
      <div>
        <p>{{ $t('accountmanager.inputtext') }}</p>
        <my-input :max="1000000" :isInt="true" v-model="submitAmountByCard"></my-input>
        <div style="height: 10px"></div>
        <div style="width: 100%">
          <el-button style="width: 100%" type="primary" @click="handleManual">
            {{ $t('btns.confirm') }}</el-button
          >
        </div>
      </div>
    </el-dialog> -->
  </el-card>
</template>

<script>
import ordersApi from '@/api/orders';
import { debounce } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import RangeDatePicker from '../cuscom/range-date-picker.vue';
import { Loading } from 'element-ui';
// import cardDialog from './card-dialog.vue';
import base from '@/mixin/base.js';
export default {
  mixins: [base],
  name: 'Orders',
  components: { RangeDatePicker },
  data() {
    return {
      tableLoading: false,
      searchLoading: false,
      refresh: false,
      refInterval: null,
      form: {
        // @TODO - 第三方目前没有这边栏目，先行干掉后期再说
        submitTime: '',
        merchatNo: '',
        merchatOrderNo: '',
        systemOrderNo: '',
        channelType: '',
        patchStatus: '',
        callbackStatus: '',
        orderStatus: '',
        description: '',
        amountStart: '',
        amountEnd: '',
        submitTimeStart: '',
        submitTimeEnd: '',
        payoutTimeStart: '',
        payoutTimeEnd: ''
      },
      visibleDialog: false,
      submitAmountByCard: '',
      pagination: {
        current: 1,
        size: 100
      },

      tableData: {}, // 表格数据
      totalData: {}, // 统计数据
      channelTypeList: [] // 订单渠道类型
    };
  },
  computed: {
    ...mapGetters(['permission', 'CREATE_ORDER']),
    info() {
      return this.$store.state.user.info;
    },
    userType() {
      return this.$store.state.user.userType;
    },
    visibleDialogBool: {
      get() {
        return !!this.visibleDialog;
      },
      set(v) {
        this.visibleDialog = v;
      }
    },
    tableList() {
      // 表格list
      return this.tableData.list || [];
    },
    btnsTime() {
      return this.$t('orders.btns');
    },
    statusData() {
      return {
        patchType: [
          {
            val: -1,
            type: 'danger',

            label: this.$t('status.error8')
          },
          {
            val: 0,
            type: 'danger',
            label: this.$t('status.error9')
          },
          {
            val: 1,
            type: 'danger',

            label: this.$t('status.error10')
          }
        ],
        patchStatus: [
          {
            val: -1,
            type: 'danger',

            label: this.$t('status.error7')
          },
          {
            val: 0,
            type: 'success',

            label: this.$t('status.success6')
          },
          {
            val: 1,
            type: 'danger',

            label: this.$t('status.error8')
          },
          {
            val: 2,
            type: 'info',

            label: this.$t('status.doing3')
          }
        ],
        callbackStatus: [
          {
            val: -1,
            type: 'danger',
            label: this.$t('status.error5')
          },
          {
            val: 0,
            type: 'info',
            label: this.$t('status.error4')
          },
          {
            val: 1,
            type: 'success',
            label: this.$t('status.success4')
          }
        ],
        orderStatus: [
          // {
          //   val: -9,
          //   type: 'info',
          //   label: this.$t('status.error11')
          // },
          // {
          //   val: -1,
          //   type: 'danger',
          //   label: this.$t('status.error6')
          // },
          {
            val: 1,
            type: 'success',
            label: this.$t('status.success5')
          },
          {
            val: 0,
            type: 'info',
            label: this.$t('status.doing2')
          },
          {
            val: 2,
            type: 'success',
            label: this.$t('status.success6')
          },
          // {
          //   val: 88,
          //   type: 'danger',
          //   label: this.$t('status.doing88')
          // }
        ]
      };
    }
  },
  watch: {
    CREATE_ORDER(n) {
      // this.tableData = {
      //   ...this.tableData,
      //   total: this.tableData.total + 1,
      //   records: [n, ...this.tableList]
      // };
      const _n = n || {};
      this.$notify.success(this.$t('tips.tip3', { money: _n.submitAmount }));
      debounce(() => {
        this._handleSearch();
      }, 2000)();
    }
  },
  created() {
    this.init();
  },
  mounted() {
    this.getTableData();
    this.getTotalData();
    this.getChannelTypeData();
    this.handleTime();
    this.refTableData();
  },
  methods: {
    ...mapActions(['WEBSOCKET_INIT', 'handleOpenWs']),
    needChangeColor(money) {
      const color = money >= 10000000 ? '#42b983' : 'black';
      return { color };
    },
    handleSetDateTime(dateArr) {
      [this.form.submitTimeStart, this.form.submitTimeEnd] = dateArr;
    },
    handleShowRangeTime(val) {
      [this.form.payoutTimeStart, this.form.payoutTimeEnd] = val;
    },
    init() {
      this.handleSearch = debounce(()=>{
        this.searchLoading=true;
        this._handleSearch()
      }, 300);

      /* ----------------------------- element -props ----------------------------- */
      this.formProps = {
        form: {
          ref: 'form',
          'label-width': 'auto',
          inline: true,
          size: 'small',
          rules: {}
        }
      };
    },
    formatParams() {
      return {
        ...Object.keys(this.form).reduce((acc, key) => {
          if (this.form[key] === 0 || this.form[key]) {
            acc[key] = this.form[key];
          }
          return acc;
        }, {})
      };
    },
    async getTableData() {
      this.tableLoading = true;
      const { data } = await ordersApi.getTableData({
        data: { query: { ...this.formatParams() }, ...this.pagination }
      });
      if (data && data.code === 200) {
        this.tableData = data.data;
        this.tableLoading = false;
      } else {
        this.tableLoading = false;
        this.$message.error(data.msg);
      }
      this.searchLoading=false;
    },
    async getTotalData() {
      const { data } = await ordersApi.getTotalData(this.formatParams());
      if (data && data.code === 200) {
        this.totalData = data.data;
      } else {
        this.$message.error(data.msg);
      }
    },
 
    async getChannelTypeData() {
      const { data } = await ordersApi.getChannelTypeData();
      if (data && data.code === 200) {
        this.channelTypeList = data.data || [];
      } else {
        this.$message.error(data.msg);
      }
    },
    handleEmpty() {
      this.form = {
        submitTime: '',
        merchatNo: '',
        patchStatus: '',
        submitTimeStart: '',
        submitTimeEnd: '',
        merchatOrderNo: '',
        systemOrderNo: '',
        channelType: '',
        callbackStatus: '',
        orderStatus: '',
        description: '',
        amountStart: '',
        amountEnd: ''
      };
      this.$refs.datePick.handleTime();
      this.$refs.rangeDatePick.handleTime();
    },
    _handleSearch() {
      if (this.$refs.form) {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            this.getTableData();
            this.getTotalData();
          }
        });
      }
    },
    async getCallback({ systemOrderNo }) {
      const Code = await this.promptGoogleCode();
      if (!Code) return;
      const { data, config } = await ordersApi.getCallback({
        systemOrderNo:systemOrderNo,
        patchGoogleCode: Code.value
      });
      localStorage.setItem(`${this.info.userName}-${Date.now()}`, config.url);
      if (data) {
        if (data.code === 200) {
          this.$message.success(this.$t('status.success'));
          this.getTableData();
        } else {
          this.$message.error(data.msg);
        }
      }
    },
    async getManual(row) {
      const { channelType, systemOrderNo, submitAmount } = row;
      const Code = await this.promptGoogleCode(submitAmount);
      if (!Code) return;
      const { data, config } = await ordersApi.getManual({
        systemOrderNo:systemOrderNo,
        patchGoogleCode: Code.value
      });
      if (data) {
        if (data.code == 200) {
          this.$message.success(this.$t('status.success'));
          this.getTableData();
        } else {
          this.$message.error(data.msg);
        }
      }
      localStorage.setItem(`${this.info.userName}-${Date.now()}`, config.url);
    },
  
    refTableData() {
      if (this.refresh) {
        this.refInterval = setInterval(() => {
          this._handleSearch();
        }, 60000);
      } else {
        clearInterval(this.refInterval);
      }
    },
    async handleExport() {
      const { data } = await ordersApi.handleExport(this.formatParams());
      if (data) {
        const BLOB = data;
        const fileReader = new FileReader();
        fileReader.readAsDataURL(BLOB);
        fileReader.onload = (event) => {
          // 处理load事件。该事件在读取操作完成时触发
          // 新建个下载的a标签，完成后移除。
          let a = document.createElement('a');
          a.download = `Merchant-Orders-${Number(new Date())}.xlsx`;
          a.href = event.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      } else {
        this.$message.error(this.$t('status.error'));
      }
    },
    handleTime(type = '', field) {
      const date = new Date();
      // 当天零点
      const zeroTime = new Date(date.toLocaleDateString()).getTime();
      // 当年
      const nowY = date.getFullYear();
      // 当月
      const nowM = date.getMonth();
      // 当月第一天
      const firstDayNow = new Date(nowY, nowM, 1);
      // 上月第一天
      const firstDayNow1 = new Date(nowY, nowM - 1, 1);
      let start = '';
      let end = '';
      let tempDay = '';
      switch (type) {
        case 'today':
          start = this.timestamp(zeroTime);
          end = this.timestamp(zeroTime + 24 * 60 * 60 * 1000 - 1);
          break;
        case 'yesterday':
          if (this.form.submitTimeStart && field == 'submit') {
            tempDay = new Date(new Date(this.form.submitTimeStart).toLocaleDateString()).getTime();
            start = this.timestamp(tempDay - 60 * 60 * 24 * 1000);
            end = this.timestamp(tempDay - 1);
          } else if (this.form.payoutTimeStart && field != 'submit') {
            tempDay = new Date(new Date(this.form.payoutTimeStart).toLocaleDateString()).getTime();
            start = this.timestamp(tempDay - 60 * 60 * 24 * 1000);
            end = this.timestamp(tempDay - 1);
          } else {
            start = this.timestamp(zeroTime - 60 * 60 * 24 * 1000);
            end = this.timestamp(new Date(new Date().toLocaleDateString()).getTime() - 1);
          }
          break;
        case 'tomorrow':
          start = this.timestamp(zeroTime);
          end = this.timestamp(zeroTime + 60 * 60 * 24 * 1000);
          break;
        case 'month':
          start = this.timestamp(firstDayNow);
          end = this.timestamp(zeroTime + 24 * 60 * 60 * 1000 - 1);
          break;
        case 'lastMonth':
          start = this.timestamp(firstDayNow1);
          end = this.timestamp(new Date(firstDayNow).getTime() - 1);
          break;
        default:
          break;
      }
      if (field === 'submit') {
        this.form.submitTimeStart = start;
        this.form.submitTimeEnd = end;
      } else {
        this.form.payoutTimeStart = start;
        this.form.payoutTimeEnd = end;
      }
    },
    timestamp(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss');
    },
    getOrderClass(status) {
      switch (status) {
        case 2:
          return 'orderStatus-2';
        default:
          return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-date-editor.el-input {
  width: 200px;
}
/deep/ .el-table .el-button{
  display: block;
}
.orderStatus-2 {
  color: red; /* 订单状态为2 补单成功的文字颜色 */
}
.header-table {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  padding-right: 40px;
}

.header-table .list-table {
  display: flex;
  list-style: none;
}

.header-table .list-table li {
  display: flex;
  list-style: none;
}

.header-table .list-table li .label {
  font-style: normal;
}

.header-table .list-table li .value {
  display: flex;
  list-style: none;
}

.header-table .list-table li:nth-child(n + 2) {
  margin-left: 30px;
}

.header-table .btn-table {
  margin-left: auto;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(0, 0, 0, 0) !important;
}
/deep/ .el-switch {
  margin-right: 30px;

  .el-switch__label--left {
    margin-right: 10px;
  }

  .el-switch__label--right {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orders/orders.vue